import { useState } from "react";
import { Menu, X, Orbit } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "EXPLORE", target: "#explore", testid: "nav-link-explore" },
  { label: "INNER WORK", target: "#inner-work", testid: "nav-link-inner-work" },
  { label: "FREQUENCY", target: "#energy", testid: "nav-link-frequency" },
  { label: "COMMUNITY", target: "#community", testid: "nav-link-community" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (target) => {
    setOpen(false);
    scrollToId(target);
  };

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-[#040308]/60 backdrop-blur-2xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-2.5 text-slate-100 transition-colors duration-300 hover:text-cyan-300"
        >
          <Orbit className="h-5 w-5 text-cyan-300" strokeWidth={1.5} />
          <span className="font-display text-sm font-bold tracking-[0.35em]">THE SHIFT</span>
        </button>

        <nav className="hidden items-center gap-8 md:flex" data-testid="nav-desktop-menu">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={l.testid}
              onClick={() => go(l.target)}
              className="font-display text-[11px] tracking-[0.3em] text-slate-400 transition-colors duration-300 hover:text-cyan-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-enter-btn"
            onClick={() => go("#community")}
            className="rounded-full border border-cyan-300/40 px-5 py-2 font-display text-[11px] font-bold tracking-[0.25em] text-cyan-200 transition-all duration-300 hover:bg-cyan-300/10 hover:shadow-[0_0_24px_rgba(0,245,212,0.35)]"
          >
            ENTER
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="text-slate-200 md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="border-t border-white/10 bg-[#040308]/95 px-6 py-6 backdrop-blur-2xl md:hidden"
        >
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.label}
                data-testid={`${l.testid}-mobile`}
                onClick={() => go(l.target)}
                className="text-left font-display text-xs tracking-[0.35em] text-slate-300 transition-colors duration-300 hover:text-cyan-300"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-enter-btn-mobile"
              onClick={() => go("#community")}
              className="btn-portal mt-2 w-full !py-3 text-center"
            >
              ENTER THE SHIFT
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}
